import { OrderDetailModel } from "./@types/orderDetail.model";

export const $OrderDetailModuleName = "orderDetail";

export type TOrderDetailsState = OrderDetailModel;
